var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.4,1.3h-1.9V0.5c0-0.3-0.2-0.5-0.5-0.5H3.9C3.7,0,3.4,0.2,3.4,0.5v0.8H1.6C0.7,1.3,0,2,0,2.9v11.6 C0,15.3,0.7,16,1.6,16h12.8c0.9,0,1.6-0.7,1.6-1.6V2.9C16,2,15.3,1.3,14.4,1.3z M4.4,1h7.2v0.8c0,0.3-0.3,0.6-0.6,0.6H5.2 C4.8,2.3,4.4,2,4.4,1.5V1z M15,14.4c0,0.3-0.3,0.6-0.6,0.6H1.6C1.2,15,1,14.8,1,14.4V2.9c0-0.3,0.3-0.6,0.6-0.6h2 c0.3,0.6,0.9,1,1.6,1H11c0.7,0,1.2-0.4,1.4-1h1.9c0.3,0,0.6,0.3,0.6,0.6V14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2,5.9H6.4c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5h4.8c0.3,0,0.5-0.2,0.5-0.5 C11.7,6.1,11.5,5.9,11.2,5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7,6c-0.2-0.1-0.4,0-0.5,0.1C4.1,6.2,4,6.3,4,6.4c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0.1,0.1,0.2,0.1 c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.1C5,6.7,5,6.5,5,6.4C5,6.3,5,6.2,4.9,6.1C4.8,6,4.8,6,4.7,6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2,8.2H6.4c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h4.8c0.3,0,0.5-0.2,0.5-0.5S11.5,8.2,11.2,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2,8.4C4.1,8.5,4,8.6,4,8.7c0,0.1,0,0.1,0,0.2C4.1,9,4.1,9,4.2,9.1c0.1,0.1,0.2,0.1,0.3,0.1 c0.1,0,0.2,0,0.3-0.1C4.9,9,5,9,5,8.9c0-0.1,0-0.1,0-0.2C5,8.6,5,8.5,4.9,8.4C4.7,8.2,4.4,8.2,4.2,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2,10.6H6.4c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h4.8c0.3,0,0.5-0.2,0.5-0.5S11.5,10.6,11.2,10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2,10.7c0,0-0.1,0.1-0.1,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.3c0,0,0.1,0.1,0.2,0.1 c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3-0.1C5,11.3,5,11.2,5,11c0-0.1-0.1-0.3-0.1-0.3C4.7,10.5,4.4,10.5,4.2,10.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskIcon);
export default __webpack_public_path__ + "static/media/task-icon.a4145cea5778b81f0cc34741efa339b6.svg";
export { ForwardRef as ReactComponent };